import TeamNavItem from './TeamNavItem';

export default TeamNavItem;
